import React from 'react'
import { TextField } from '@mui/material'
import { com } from '@eidu/form'
import DraftFieldValue from '../../domain/entity/DraftFieldValue'
import Field = com.eidu.sharedlib.entity.field.Field

export type EntityFormDateDisplayProps = {
  field: Field
  fieldValue: DraftFieldValue | undefined
}

const EntityFormDateDisplay = ({ field, fieldValue }: EntityFormDateDisplayProps) => (
  <TextField disabled required={field.required} label={field.name} value={fieldValue?.value ?? ''} />
)

export default EntityFormDateDisplay
